<!--账号找回-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="企业账号找回"
    append-to-body
    class="find-account"
    width="500px"
    @close="toClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-suffix="："
      label-width="150px"
    >
      <el-form-item prop="name" required label="企业全称">
        <el-input v-model="form.name" placeholder="请输入企业全称" />
      </el-form-item>
      <el-form-item prop="phone" label="新手机号码">
        <el-input v-model="form.phone" placeholder="请输手机号码" />
      </el-form-item>
      <el-form-item prop="code" label="短信验证码">
        <el-input v-model="form.code" placeholder="请输短信验证码" >
          <div slot="suffix" class="padding-lr-sm code-btn">
            <el-button :disabled="codeTime !== 60" type="text"
                       @click="toGetCode">
              {{ codeTime === 60?'获取验证码':`${codeTime}s后重试` }}
            </el-button>
          </div>
        </el-input>
      </el-form-item>
      <el-form-item label="盖公章的营业执照" prop="businessLicense">
        <Upload v-model="form.businessLicense" :limit="1"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button @click="toClose">取消</el-button>
      <el-button
        :loading="isLoading"
        type="primary"
        @click="toSave"
      >
        保存
      </el-button>
    </div>
  </el-dialog>
</template>
<script type="text/ecmascript-6">
import { rulesRequired, rulesPhone } from '@/assets/js/validate'
import Upload from '@/components/upload/index.vue'
export default {
  components: {
    Upload
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        businessLicense: [],
        code: ''
      },
      codeTime: 60,
      isLoading: false,
      rules: {
        name: rulesRequired('请输入企业全称'),
        phone: [
          rulesRequired('请输入手机号码'),
          rulesPhone('请输入正确的手机号码')
        ],
        businessLicense: rulesRequired('请上传盖章的营业执照'),
        code: rulesRequired('请输入短信验证码')
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val) // dialogVisible改变的时候通知父组件
      }
    }
  },
  methods: {
    toClose() {
      this.dialogVisible = false
      this.$emit('close')
      this.$refs['form'].resetFields()
    },
    toGetCode() {
      this.$refs['form'].validateField('phone', (errorMsg) => {
        if (!errorMsg) {
          this.timeCountDown()
          this.$api.getCode({ phone: this.form.phone, purpose: 6 }, () => {})
        }
      })
    },
    timeCountDown() {
      if (this.codeTime === 0) {
        this.codeTime = 60
        return
      }
      setTimeout(() => {
        this.codeTime--
        this.timeCountDown()
      }, 1000)
    },
    toSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.isLoading = true
          this.$api.findAccount(
            {
              ...this.form,
              businessLicense: this.form.businessLicense + ''
            },
            () => {
              this.isLoading = false
              this.$message.success(
                '您找回账号信息已经提交成功，请您耐心等待客服人员处理'
              )
              // 上传成功后清空
              this.$refs['form'].resetFields()
              this.toClose()
            }
          )
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.code-btn{
  border-left: 1px solid #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/assist/login/findAccountDialog.vue